import { Pipe, PipeTransform } from '@angular/core';
import { format, parseISO } from 'date-fns';

export const formatDate = (date: any) => {
  if (date) {
    return format(parseISO(date), 'MM-dd-yyyy');
  }
  return date;
};

export const formatDateTime = (date: any) => {
  if (date) {
    return format(parseISO(date), 'MM-dd-yyyy hh:mm a');
  }
  return date;
};

@Pipe({
  name: 'formatDate',
  standalone: false,
})
export class FormatDate implements PipeTransform {
  transform(date: any) {
    return formatDate(date);
  }
}

@Pipe({
  name: 'formatDateTime',
  standalone: false,
})
export class FormatDateTime implements PipeTransform {
  transform(date: any) {
    return formatDateTime(date);
  }
}
